import type { ChatConfig } from '../../types/chat'
import styles from './ChatFooter.module.css'

interface Props {
  config: ChatConfig
}

export default function ChatFooter({ config: _config }: Props) {
  return (
    <div className={styles.footer} data-part="footer">
      Powered by{' '}
      <a href="https://nullacht15.com" target="_blank" rel="noopener noreferrer">
        nullacht15
      </a>
    </div>
  )
}
